// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"225":"template","272":"order-form"}[chunkId] || chunkId) + "." + {"225":"448a93d4","272":"b931e9c3","846":"624dc8e3"}[chunkId] + ".css";
};